import { useReducer } from "react";
import {
  ModalActionsEnum,
  modalInitialState,
  modalReducer
} from "../components/rlcloudsandbox/modal.reducer";

/** ActionsModal closes itself with a bare `{ show: false }`. */
export type ToggleModalProps =
  | { show: true; modalName: string; modalData?: unknown }
  | { show: false };

const useActionsModal = () => {
  const [modalState, dispatch] = useReducer(modalReducer, modalInitialState);

  const onToggleModal = (props: ToggleModalProps) =>
    dispatch(
      props.show
        ? {
            type: ModalActionsEnum.ON,
            payload: {
              show: true,
              name: props.modalName,
              data: props.modalData
            }
          }
        : { type: ModalActionsEnum.OFF, payload: modalInitialState }
    );

  return { modalState, onToggleModal };
};

export default useActionsModal;
